<div class="wrapper">
  <div *ngIf="adminRole==0">
    <span *ngIf="adminRole==0" class="custom_heading1"></span>
  </div>
  <!-- 
  <span style="float: right; position: relative; z-index: 99;" class="mt-1">
    <button class="back-button btn" [ngClass]="adminRole===0 ? 'backbutton-align' : 'margins'" (click)="backButton()">
      <i class="fas fa-arrow-left back-arrow"></i>
    </button>
  </span> -->
  <div *ngIf="adminRole === 0" class="emp-search d-flex justify-content-start col-3 p-0 search-style">
    <div class="input-group" *ngIf="isEmployeeEditable && isemployeesearchhide ">
      <div class="emp_search_container flex-column flex-md-row">
        <span class="custom_subtiles2 fw-500">Enter Employee ID/ Name</span>

        <div class="search-bar mx-1">
          <input type="text" class="form-control" aria-label="Number" matInput [(ngModel)]="currentEmployee"
            (input)="getFilteredValues($event.target.value)" (onfocus)="getFilteredValues('')"
            [matAutocomplete]="partner">
          <button type="submit" class="msicon append_button"><span class="material-symbols-outlined">
              search</span></button>
        </div>
        <mat-autocomplete autoActiveFirstOption #partner="matAutocomplete"
          (optionSelected)='setCurrentEmployee($event.option.id)'>
          <mat-option *ngFor="let partner of filteredValues" [id]="partner.employeeId" [value]="partner.name">
            {{partner.name}} ({{partner.employeeId}})
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
  </div>

  <hr *ngIf="isEmployeeEditable && isemployeesearchhide" >

  <div class="main-content pt-2">
    <div class="employee-profile-section ">
      <div class="employee-details">
        <div class="employee-name">
          {{employee.firstName}}&nbsp;{{employee.lastName}}
        </div>
        <div class="employee-designation">
          <span>{{employee.grade}}</span>
          <span class="basic_info_details_seperater"></span>
          <span>{{employee.designation}}</span>
          <span class="basic_info_details_seperater"></span>
          <span>{{employee.employeeId}}</span>
          <span class="basic_info_details_seperater"></span>
          <span>{{employee.exp}} exp</span>
        </div>
      </div>
      <div class="profile-resume-section" >
        <div class="upload-section" *ngIf="!isUploadBtnVisible">
          <div class="resume-upload custom_btn">
            <span class="resume-know-how" mat-raised-button #tooltipTrigger
              aria-tooltip="text that hovers will displays the resume form fill details "
              [matTooltip]="['Resume upload guide:',' Download template'] | tooltipList" matTooltipClass="tooltip-list"
              (click)="tooltip.show()">Don't have a resume template?</span>
          </div>
          <div class="d-flex align-items-center"> 
            <span class="material-symbols-outlined cursor-pointer download-icon-template"> download </span>
            <a (click)="donloadResumeFormat()" class="download-template cursor-pointer">Download Template</a> 
          </div>
        </div>
        <div class="drag-section" *ngIf="!employee.resume || employee.resume.name==null">
          <div><span class="material-symbols-outlined">cloud_upload</span></div>
          <div class="drag-text">
          <div class="upload-text">Upload Resume</div>
          <div class="drag-files">Drag your file(s) or <a class="drag-browse-files">browse<input #resumeFile type="file" accept=".doc, .docx" class="form-control" name="file" id="resumeFile" (change)="onResumeUpload($event)"></a></div>
        </div></div>
        <div class="view-section" *ngIf="employee.resume&&employee.resume.name!=null">
          <div class="resume-upload-container d-flex align-items-center">
            <div [ngClass]="{'dottedline': isUploadBtnVisible === true}">
              <div class="resume_chips  align-items-center">
                <div class="file-name d-flex h5 mr-1 mb-0 " [title]="employee.resume?.name">
                  <span class="material-symbols-outlined document-icon">description</span>
                 <span class="resume-name">{{employee.resume?.name}}</span>
                </div>
                <span *ngIf="isUploadBtnVisible" (click)="deleteResume()" class="material-symbols-outlined cursor-pointer">
                  close
                </span>
                <div class="kebab-menu ml-2" *ngIf="employee.resume?.sharepointId">
                  <span class="material-symbols-outlined cursor-pointer" [matMenuTriggerFor]="menu">more_vert</span>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="viewFile(employee.resume?.sharepointId)">
                      <span class="material-symbols-outlined menu-icon">visibility</span> View
                    </button>
                    <button mat-menu-item>
                      <span class="material-symbols-outlined menu-icon">edit</span> Update
                      <input type="file" accept=".doc, .docx" class="hidden-file-input"
                        (change)="updateResume($event)">
                    </button>
                    <button mat-menu-item (click)="downloadResume(employee.resume?.sharepointId, employee.resume?.name)">
                      <span class="material-symbols-outlined menu-icon">download</span> Download
                    </button>
                    <button mat-menu-item (click)="deleteResume()">
                      <span class="material-symbols-outlined menu-icon">delete</span> Delete
                    </button>
                  </mat-menu>
                </div>
              </div>
            </div>
            
            <button mat-flat-button class="custom_btn primary_btn_base upload-btn " 
              *ngIf="isUploadBtnVisible"
              (click)="uploadResume()">
              <span class="material-symbols-outlined upload-icon">upload</span><b>Upload</b>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- domain expertise section -->
    <div class="main_heading pb-3 mt-3">Vertical Expertise</div>
    <div class="bg-white br-5 p-4">
      <div class="row m-0" *ngIf="!uncompetencyEmployee">
        <div class="domain_expertise">
          <div class="domain-section" *ngIf="employee.employeeId">
            <div class="d-flex flex-column align-items-center">
              <span class="main_head">What vertical(s) are you familiar with and can you provide solutions for? </span>
              <span class="sub_head">Multiselect which all are applicable <sup class="text-danger mt-2">*</sup> </span>
            </div>
            <div class="container pb-0  d-flex flex-wrap pt-4 expertises">
              <div class="d-flex justify-content-center domainItem" *ngFor="let domain of domainsList">
                <mat-checkbox class="custom-mdc-checkbox custom_mdc_checkbox" [checked]="getDomainValue(domain)"
                  (change)="domainChange($event,domain)" [disabled]="isViewMode">
                  <span class="material-symbols-outlined domain_icon">{{domain.icon}}</span>
                  <span class="domain_text">{{domain.name}}</span>
                </mat-checkbox>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- domain expertise section end-->


    <div class="competency_section mt-3" *ngIf="subCompetency && !uncompetencyEmployee">
      <div class="main_heading pb-3">Competency</div>

      <div class="bg-white br-5 p-4">
        <button mat-flat-button class="btn_blue competency_btn" (click)="openAddCompetencyDialog()">Add
          Competency</button>

        <div *ngFor="let competency of employee?.competencies;let i=index">
          <mat-accordion class="accordion_section"
            *ngFor="let subCompetency of competency?.subCompetencies;let ind=index">
            <mat-expansion-panel [id]="'panel_Comp_'+competency.competencyId+'_subComp_'+subCompetency.subCompetencyId"
              [expanded]="subCompetency.isExpanded" (opened)="AccordionExpand(subCompetency,competency)">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span class="title">{{subCompetency.subCompetencyName}}</span> <span class="verical_line">|</span>
                  <span class="sub_title">{{competency.competencyName}}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="accordion_content">
                <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChange(subCompetency)">
                  <mat-tab>
                    <ng-template mat-tab-label>
                      <div class="d-flex align-items-center">
                        <span class="material-symbols-outlined mr-2 fs_20">approval_delegation</span>
                        <span>Areas of Expertise</span>
                      </div>
                    </ng-template>
                    <div class="aoe-section">
                      <div class="beginner_cards">
                        <div class="row m-0">
                          <div class="col-4">
                            <div class="mb-1 heading">Beginner</div>
                            <div class="description"
                              title="You have received training and gained practical experience by working on 1-2 projects, or you have relevant project experience of 6 months.">
                              You have received training and gained practical experience by working on 1-2 projects, or
                              you have relevant project experience of 6 months.</div>
                          </div>
                          <div class="col-4">
                            <div class="mb-1 heading">Intermediate</div>
                            <div class="description"
                              title="You have actively participated in and contributed to 3-6 projects, or you possess relevant project experience ranging from 6 months to 3 years.">
                              You have actively participated in and contributed to 3-6 projects, or you possess relevant
                              project experience ranging from 6 months to 3 years.
                            </div>
                          </div>
                          <div class="col-4">
                            <div class="mb-1 heading">Expert</div>
                            <div class="description"
                              title="You have extensively worked on more than 6+ projects, showcasing your expertise and a deep understanding of the service line. Additionally, you possess significant project experience of 3 years or more, demonstrating your ability to consistently deliver successful outcomes in various projects.">
                              You have extensively worked on more than 6+ projects, showcasing your expertise and a deep
                              understanding of the service line. Additionally, you possess significant project
                              experience
                              of 3 years or more, demonstrating your ability to consistently deliver successful outcomes
                              in various projects.</div>
                          </div>
                        </div>
                      </div>

                      <div class="fw-600 w-50 mx-auto text-center mb-3">Given your expertise across different verticals,
                        could
                        you provide a summary of the number of projects you've worked on and your relevant experience?
                      </div>

                      <div class="expertise_section">
                        <div class="main_section">
                          <div class="dummy_section"></div>
                          <div class="header_section d-flex align-items-center">
                            <div>Beginner</div>
                            <div>Intermediate</div>
                            <div>Expert</div>
                            <!-- <div class="mainsection_columns">Exposure<sup
                                class="content_section material-symbols-outlined fs-16 info"
                                [ngbTooltip]="tooltipContent" tooltipClass="mytooltipdata custom_tooltip"
                                placement="right">info</sup></div>
                            <ng-template #tooltipContent class="mytooltipdata custom_tooltip tooltip-inner">
                              Exposure is having some hands on experience or practical knowlegdge in that particular
                              vertical
                            </ng-template> -->
                            <div class="headerSectionColumns">Project Count</div>
                            <div class="experience align-items-center experienceColumn">Experience
                              <div class="yearsMonthsSection">
                                <span for="years">Years</span>
                                <span for="months">Months</span>
                              </div>
                            </div>
                            <div class="radio_section headerSectionColumns">
                              <mat-radio-button class="custom-radio clear_btn" [name]="index" value="None"
                                [disabled]="isViewMode " (click)="clearSelectedAreas()">Clear</mat-radio-button>
                            </div>

                          </div>
                        </div>

                        <ng-container *ngFor="let area of subCompetency?.serviceAreas; let index = index;">
                          <div class="content_section">
                            <div class="first_section pl-4 ml-2">
                              <span class="content_title">{{area.name ? area.name : area.serviceArea}}</span> <sup
                                *ngIf="getServiceAreaInfo(area.serviceAreaInfo)"
                                class="material-symbols-outlined fs-16 info" [ngbTooltip]="tipContent"
                                tooltipClass="mytooltip custom_tooltip" placement="right">
                                info
                              </sup>
                              <ng-template #tipContent class="mytooltip custom_tooltip">
                                <div class="m-0 tooltipdata" [innerHTML]="getServiceAreaInfo(area.serviceAreaInfo)">
                                </div>
                              </ng-template>
                            </div>

                            <div class="second_section d-flex align-items-center">
                              <div class="radio_section">
                                <mat-radio-button class="custom-radio"
                                  [name]="subCompetency.subCompetencyName+area.serviceArea" value="1"
                                  [checked]="area.proficiency == 1"
                                  (change)="updatedServiceArea($event, index, area.name, area.serviceArea, subCompetency.serviceAreas)"
                                  [disabled]="isViewMode">
                                </mat-radio-button>
                              </div>

                              <div class="radio_section">
                                <mat-radio-button class="custom-radio"
                                  [name]="subCompetency.subCompetencyName+area.serviceArea" value="2"
                                  [checked]="area.proficiency == 2"
                                  (change)="updatedServiceArea($event,index,area.name,area.serviceArea,subCompetency.serviceAreas)"
                                  [disabled]="isViewMode"></mat-radio-button>
                              </div>

                              <div class="radio_section">
                                <mat-radio-button class="custom-radio"
                                  [name]="subCompetency.subCompetencyName+area.serviceArea" value="3"
                                  [checked]="area.proficiency == 3"
                                  (change)="updatedServiceArea($event,index,area.name,area.serviceArea,subCompetency.serviceAreas)"
                                  [disabled]="isViewMode"></mat-radio-button>
                              </div>

                              <!-- <div class="radio_section">
                                <input #exposureInput type="number" name="exposureCount"
                                  [(ngModel)]="area.exposureCount"
                                  [disabled]="isViewMode || area.proficiency == 4 || area.editingField === 'projectCount'"
                                  (blur)="projectInputFocused = false" class="form-control num_box" />
                              </div> -->

                              <div class="radio_section">
                                <input #projectInput type="number" name="projectCount" [(ngModel)]="area.projectCount"
                                  (keyup)="updateProjectCountValidation('isInvalidProjectRange', area)"
                                  [disabled]="isViewMode || area.proficiency == 4"
                                  [ngClass]="area.isInvalidProjectRange ? 'is-invalid1' : ''"
                                  (blur)="exposureInputFocused = false" class="form-control num_box" />
                                <sup class="text-danger mt-2">*</sup>
                              </div>

                              <div class="radio_section mandatory">
                                <input type="number" class="experienceYears" id="years" [min]="0" [max]="99"
                                  class="form-control num_box" name="experienceYears" [(ngModel)]="area.experienceYears"
                                  (keyup)="updateExperienceYearsValidation('isInvalidExperienceRange', area,1)"
                                  [disabled]="isViewMode || area.proficiency == 4"
                                  [ngClass]="area.isInvalidExperienceRange ? 'is-invalid1' : ''" />
                              </div>
                              <div class="radio_section mandatory">
                                <input type="number" class="form-control num_box experienceMonths" [min]="0" [max]="11"
                                  id="months" name="experienceMonths" type="number" [(ngModel)]="area.experienceMonths"
                                  (keyup)="updateExperienceMonthsValidation('isInvalidExperienceRange', area,1)"
                                  [disabled]="isViewMode || area.proficiency == 4"
                                  [ngClass]="area.isInvalidExperienceRange ? 'is-invalid1' : ''" />
                              </div>




                              <div class="radio_section">
                                <mat-checkbox class="custom_mdc_checkbox clearBtnCheckBox" [(ngModel)]="area.isChecked"
                                [disabled]="!(area.proficiency === 1 || area.proficiency === 2 || area.proficiency === 3)">
                                </mat-checkbox>
                              </div>

                            </div>
                          </div>
                        </ng-container>


                      </div>


                    </div>
                  </mat-tab>

                  <mat-tab>
                    <ng-template mat-tab-label>
                      <div class="d-flex align-items-center">
                        <span class="material-symbols-outlined mr-2 fs_20">psychology</span>
                        <span>Skills</span>
                      </div>
                    </ng-template>


                    <div class="accordian_data_sections">
                      <div class="d-flex flex-row justify-content-between align-items-center">
                        <div class="d-flex flex-column mb-2">
                          <div>
                            <span class="skills_title">Primary skills&nbsp;</span>
                            <span *ngIf="!isViewMode" class="validation_info">(Minimum one primary skills is required
                              <sup>*</sup> )</span>
                          </div>
                          <div class="mt-1 h5">
                            Fill in the most important skills that you have a lot of experience with and have
                            successfully
                            used
                            to solve problems.
                          </div>
                        </div>
                        <div class="add_buttons " [ngClass]="this.isViewMode ? 'corser-disable' : 'cursor-pointer'">
                          <button mat-flat-button class="btn_blue competency_btn mb-0" [disabled]="this.isViewMode"
                            [ngClass]="this.isViewMode ? 'corser-disable' : 'cursor-pointer'"
                            (click)="addSkill(subCompetency?.primarySkills,true)">+ Add</button>
                        </div>
                      </div>
                      <div class="all-primary-skills">
                        <div class="individual-primary-skill row m-0 row-gap16 mt-3"
                          *ngFor="let priSkill of subCompetency.primarySkills;let index=index;">
                          <div class="col-md-3 pl-0 flex-column skill">
                            <label><b>Skill</b><sup>*</sup></label>
                            <div class="input-with-icon">
                              <input type="text" class="form-control inp" aria-label="Number" matInput
                                (input)="searchPriSkill(priSkill.skill)" [(ngModel)]="priSkill.skill"
                                placeholder="Click here to select skill"
                                (blur)="onBlurValidateSkill(priSkill, 'primary')" [ngClass]="priSkill.isInvalidSkill ? 'is-invalid1' : ''" [disabled]="isViewMode"
                                [matAutocomplete]="auto">

                            </div>

                            <mat-autocomplete #auto="matAutocomplete"
                              (optionSelected)="priSkill.skill=$event.option.value;priSkill.isInvalidSkill=false;priSkill.alreadySelectedSkill=false;onSkillSelected(priSkill, $event.option.value)">
                              <mat-option *ngFor="let option of filteredprimaryskillsItems " [value]="option.name">
                                {{ option.name }}
                              </mat-option>
                            </mat-autocomplete>
                            <div *ngIf="priSkill.alreadySelectedSkill" class="invalid-feedback">Skill already selected.
                            </div>
                          </div>
                          <div class="col-md-3 flex-column d-flex">
                            <label><b>Proficiency level</b><sup>*</sup></label>
                            <div class="btn-group" [ngClass]="priSkill.isInvalidProficiency ? 'is-invalid1' : ''">
                              <button type="button" class="btn mybtn"
                                [ngStyle]="priSkill.isInvalidProficiency ? {'border-color': 'red'} : {'border-color': ''}"
                                [ngClass]="{'active':priSkill.proficiency==1}"
                                (click)="priSkill.proficiency=1;priSkill.isInvalidProficiency=false"
                                [disabled]="isViewMode">Beginner</button>
                              <button type="button" class="btn mybtn"
                                [ngStyle]="priSkill.isInvalidProficiency ? {'border-color': 'red'} : {'border-color': ''}"
                                [ngClass]="{'active':priSkill.proficiency==2}"
                                (click)="priSkill.proficiency=2;priSkill.isInvalidProficiency=false"
                                [disabled]="isViewMode">Intermediate</button>
                              <button type="button" class="btn mybtn"
                                [ngStyle]="priSkill.isInvalidProficiency ? {'border-color': 'red'} : {'border-color': ''}"
                                [ngClass]="{'active':priSkill.proficiency==3}"
                                (click)="priSkill.proficiency=3;priSkill.isInvalidProficiency=false"
                                [disabled]="isViewMode">Expert</button>
                            </div>
                          </div>
                          <div class="col-md-3 flex-column d-flex">
                            <label><b>Experience {{priskill}}</b><sup>*</sup></label>


                            <div class="d-flex align-items-center experience_section">
                              <div class="d-flex align-items-center">
                                <label for="years2">Years</label>
                                <input type="number" id="years2" class="form-control num_box" name="experienceYears"
                                  [min]="0" [max]="99" [(ngModel)]="priSkill.experienceYears"
                                  (keyup)="updateExperienceYearsValidation('isInvalidExperienceRange', priSkill,2)"
                                  [disabled]="isViewMode"
                                  [ngClass]="priSkill.isInvalidExperienceRange ? 'is-invalid1' : ''" />
                              </div>

                              <div class="d-flex align-items-center">
                                <label for="months2">Months</label>
                                <input type="number" class="form-control num_box" id="months2" name="experienceMonths"
                                  type="number" [min]="0" [max]="11" [(ngModel)]="priSkill.experienceMonths"
                                  (keyup)="updateExperienceMonthsValidation('isInvalidExperienceRange', priSkill,2)"
                                  [disabled]="isViewMode"
                                  [ngClass]="priSkill.isInvalidExperienceRange ? 'is-invalid1' : ''" />
                              </div>
                            </div>
                          </div>


                          <div class="remove-skill col-md-2 p-0">

                            <mat-checkbox class="custom-mdc-checkbox custom_mdc_checkbox custom_mdc_checkbox2"
                              [(ngModel)]="priSkill.isCertified" [disabled]="isViewMode">
                              <span class="domain_text">Certified</span>
                            </mat-checkbox>
                          </div>

                          <div class="col-md-1 p-0 close_buttons_container make-default-skill">
                            <button class="gsd_close_btn2"
                              (click)="deletePrimarySkill(index,subCompetency.primarySkills , priSkill)" [disabled]="isViewMode">
                              <i class="material-symbols-outlined">close</i>
                            </button>
                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="accordian_data_sections py-1">
                      <hr class="boder_top">
                    </div>
                    <div class="accordian_data_sections">
                      <div class="d-flex flex-row justify-content-between align-items-center">
                        <div class="d-flex flex-column w-90 mb-2">
                          <div>
                            <span class="skills_title">Secondary skills&nbsp;</span>
                            <span *ngIf="!isViewMode" class="validation_info">(Minimum one secondary skills is required
                              <sup>*</sup> )</span>
                          </div>
                          <div class="mt-1 h5">
                            In this section, you can fill in your secondary skill sets, which you have been exposed to
                            or
                            have
                            worked with briefly in the past. Although you may need to brush up on these skills, you have
                            the
                            ability to quickly regain proficiency and work effectively with them.
                          </div>
                        </div>
                        <div class="add_buttons">
                          <button mat-flat-button class="btn_blue competency_btn mb-0"
                            [disabled]="!subCompetency.showSecondarySkillBtn"
                            [ngClass]="subCompetency.showSecondarySkillBtn  ? 'cursor-pointer' : 'disableSecBtn'"
                            (click)="addSkill(subCompetency.secondarySkills,false)">+ Add</button>
                        </div>
                      </div>
                      <div class="all-primary-skills ">
                        <div class="individual-primary-skill row m-0 row-gap16 mt-3"
                          *ngFor="let secSkill of subCompetency.secondarySkills;let index=index">
                          <div class="col-md-3 pl-0 flex-column skill">
                            <label><b>Skill</b><sup>*</sup></label>
                            <div class="input-with-icon">
                              <input type="text" class="form-control" aria-label="Number" matInput
                                [(ngModel)]="secSkill.skill" placeholder="Click here to select skill"
                                (blur)="onBlurValidateSkill(secSkill, 'secondary')"
                                [ngClass]="secSkill.isInvalidSkill ? 'is-invalid1' : ''" [disabled]="isViewMode"
                                (input)="searchSecSkill(secSkill.skill)" [matAutocomplete]="auto">
                            </div>
                            <mat-autocomplete #auto="matAutocomplete"
                              (optionSelected)="secSkill.skill=$event.option.value;secSkill.isInvalidSkill=false;secSkill.alreadySelectedSkill=false;">
                              <mat-option *ngFor="let option of filteredSecondaryskills" [value]="option.name">
                                {{option.name}}
                              </mat-option>
                            </mat-autocomplete>
                            <div *ngIf="secSkill.alreadySelectedSkill" class="invalid-feedback">Skill already selected.
                            </div>
                          </div>
                          <div class="col-md-3 flex-column d-flex">
                            <label><b>Proficiency level</b><sup>*</sup></label>
                            <div class="btn-group  profbtn">
                              <button type="button" class="btn mybtn"
                                [ngStyle]="secSkill.isInvalidProficiency ? {'border-color': 'red'} : {'border-color': ''}"
                                (click)="secSkill.proficiency=1;secSkill.isInvalidProficiency=false"
                                [ngClass]="{'active':secSkill.proficiency==1}" [disabled]="isViewMode">Beginner</button>
                              <button type="button" class="btn mybtn"
                                (click)="secSkill.proficiency=2;secSkill.isInvalidProficiency=false"
                                [ngStyle]="secSkill.isInvalidProficiency ? {'border-color': 'red'} : {'border-color': ''}"
                                [ngClass]="{'active':secSkill.proficiency==2}"
                                [disabled]="isViewMode">Intermediate</button>
                              <button type="button" class="btn mybtn"
                                (click)="secSkill.proficiency=3;secSkill.isInvalidProficiency=false"
                                [ngStyle]="secSkill.isInvalidProficiency ? {'border-color': 'red'} : {'border-color': ''}"
                                [ngClass]="{'active':secSkill.proficiency==3}" [disabled]="isViewMode">Expert</button>
                            </div>
                          </div>
                          <div class="col-md-3 flex-column d-flex">
                            <label><b>Experience</b><sup>*</sup></label>

                            <div class="d-flex align-items-center experience_section">
                              <div class="d-flex align-items-center">
                                <label for="years3">Years</label>
                                <input type="number" id="years3" class="form-control num_box" name="experienceYears"
                                  [min]="0" [max]="99" [(ngModel)]="secSkill.experienceYears"
                                  (keyup)="updateExperienceYearsValidation('isInvalidExperienceRange', secSkill,3)"
                                  [disabled]="isViewMode"
                                  [ngClass]="secSkill.isInvalidExperienceRange ? 'is-invalid1' : ''" />
                              </div>

                              <div class="d-flex align-items-center">
                                <label for="months3">Months</label>
                                <input type="number" class="form-control num_box" id="months3" name="experienceMonths"
                                  type="number" [min]="0" [max]="11" [(ngModel)]="secSkill.experienceMonths"
                                  (keyup)="updateExperienceMonthsValidation('isInvalidExperienceRange', secSkill,3)"
                                  [disabled]="isViewMode"
                                  [ngClass]="secSkill.isInvalidExperienceRange ? 'is-invalid1' : ''" />
                              </div>
                            </div>
                          </div>
                          <div class="remove-skill p-0 col-md-2">
                            <div>
                              <mat-checkbox class="custom-mdc-checkbox custom_mdc_checkbox custom_mdc_checkbox2"
                                [(ngModel)]="secSkill.isCertified" [disabled]="isViewMode">
                                <span class="domain_text">Certified</span>
                              </mat-checkbox>
                            </div>

                          </div>
                          <div class="col-md-1 p-0 close_buttons_container make-default-skill">
                            <button class="gsd_close_btn2"
                              (click)="deleteSecondarySkill(index,subCompetency.secondarySkills,secSkill)"
                              [disabled]="isViewMode"><i class="material-symbols-outlined">close</i></button>
                          </div>
                        </div>
                      </div>
                    </div>


                  </mat-tab>

                  <mat-tab>
                    <ng-template mat-tab-label>
                      <div class="d-flex align-items-center">
                        <span class="material-symbols-outlined mr-2 fs_20">workspace_premium</span>
                        <span>Certifications</span>
                      </div>
                    </ng-template>


                    <div class="accordion_panel_body accordian_data_sections mt-3">
                      <div class="pt-2">
                        <div class="d-flex justify-content-between flex-row align-items-center column-gap16">
                          <div class="d-flex flex-column w-90">
                            <div class="skills_title mb-2">Planned certifications </div>
                            <div class="h5 grey-black-clr">
                              Certifications can play a vital role in keeping you abreast of the latest technologies and
                              trends
                              while showcasing your expertise. By strategically pursuing certifications, you can ensure
                              that-
                              your
                              knowledge and skills align with the evolving demands of the industry. Please utilize this
                              section to
                              outline the certification details you plan to complete, further enhancing your
                              qualifications
                              and
                              showcasing your commitment to ongoing professional development.
                            </div>
                          </div>
                          <div class="add_buttons  certificate-upload">
                            <button mat-flat-button class="btn_blue competency_btn mb-0" [disabled]="isViewMode"
                              [ngClass]="isViewMode  ? 'corser-disable' : 'cursor-pointer'"
                              (click)="addCertification(subCompetency.certificates,1)">+ Add</button>
                          </div>
                        </div>
                        <div class="all-primary-skills">
                          <div *ngFor="let certification of subCompetency?.certificates;let index=index">
                            <div class="individual-primary-skill row m-0 mt-3 d-flex" *ngIf="certification.status == 1">
                              <div class="col-11 p-0">
                                <div class="row m-0 row-gap16">
                                  <div class="col-md-3 mat-card-header flex-column text-nowrap">
                                    <label class="type"><b>Certification Name</b><sup>*</sup></label>
                                    <div class="ml-1">
                                      <input type="text" class="form-control type" aria-label="Number" matInput
                                        [(ngModel)]="certification.type"
                                        (input)="searchCertificationtype(certification.type)"
                                        (click)="searchCertificationtype('')"
                                        [ngClass]="certification.isInvalidType ? 'is-invalid1' : ''"
                                        placeholder="Select Certification Name" [matAutocomplete]="PlannedCertificate"
                                        [disabled]="isViewMode">
                                    </div>
                                    <mat-autocomplete autoActiveFirstOption #PlannedCertificate="matAutocomplete"
                                      (optionSelected)="certification.type=$event.option.value;certification.isInvalidType=false;
                                      certification.certificateLevel=getlevel(certification.type);">
                                      <mat-option *ngFor="let type of filtercertificateType" [value]="type.name">
                                        {{type.name}}
                                      </mat-option>
                                    </mat-autocomplete>
                                    <div *ngIf="certification.alreadySelectedType" class="invalid-feedback feedback">
                                      Name
                                      already
                                      selected.</div>
                                  </div>
                                  <div class="col-md-3 flex-column d-flex">
                                    <label class="level"><b>Level</b><sup>*</sup></label>
                                    <div class="btn-group level disabled">
                                      <button type="button" class="btn mybtn"
                                        [ngClass]="{'active':certification.certificateLevel==1}"
                                        [disabled]="isViewMode">Beginner</button>
                                      <button type="button" class="btn mybtn"
                                        [ngClass]="{'active':certification.certificateLevel==2}"
                                        [disabled]="isViewMode">Intermediate</button>
                                      <button type="button" class="btn mybtn"
                                        [ngClass]="{'active':certification.certificateLevel==3}"
                                        [disabled]="isViewMode">Expert</button>
                                    </div>
                                  </div> 
                                  <div class="col-md-3">
                                    <label class="expiry"><b>{{certification.status ==
                                        1 ? "Planned date":"Date"}}</b><sup>*</sup></label>
                                    <input type="date" class="form-control expiry"
                                      [(ngModel)]="certification.plannedDate"
                                      (change)="certification.isInvalidPlannedDate=false"
                                      [ngClass]="certification.isInvalidPlannedDate ? 'is-invalid1' : ''"
                                      [disabled]="isViewMode"
                                      [min]="certification.status == 1 || certification.status == 3 ? todayDate:''" />
                                  </div>

                                  <div class="col-md-3 pl-0">
                                    <label><b>Service area</b></label>
                                    <select class="form-control completedcertificate"
                                      [(ngModel)]="certification.serviceAreaId">
                                      <option value="0" disabled selected>Select service area</option>
                                      <option *ngFor="let data of certificateServiceAreas" [value]="data.id">
                                        {{data.name}}</option>
                                    </select>
                                  </div>

                                </div>
                              </div>
                              <div class="col-1 pr-0 close_buttons_container">
                                <button class="gsd_close_btn2 planned" [disabled]="isViewMode"
                                  (click)="deleteCertification(index,certification,subCompetency?.certificates)"><i
                                    class="material-symbols-outlined">close</i></button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="accordian_data_sections py-1">
                        <hr class="boder_top">
                      </div>
                      <div>
                        <div class="d-flex justify-content-between flex-row align-items-center column-gap16">
                          <div class="d-flex flex-column w-90">
                            <div class="skills_title mb-2">Completed certifications</div>
                            <div class="h5 grey-black-clr">
                              Please utilize this section to provide details about the certifications you have
                              completed.
                              These
                              certifications serve as tangible evidence of your successful attainment of recognized
                              credentials
                              and qualifications in specific areas of expertise. Additionally, please ensure that you
                              complete
                              the
                              PAL tagging process for your certificates. Refer to the tool tip for further instructions
                              on
                              the
                              steps involved in PAL tagging.
                            </div>
                          </div>
                          <div class=" add_buttons  certificate-upload">
                            <button mat-flat-button class="btn_blue competency_btn mb-0" [disabled]="isViewMode"
                              [ngClass]="isViewMode  ? 'corser-disable' : 'cursor-pointer'"
                              (click)="addCertification(subCompetency.certificates,3)">+ Add</button>
                          </div>
                        </div>
                        <div class="all-primary-skills ">
                          <div *ngFor="let certification of subCompetency?.certificates;let index=index">
                            <div class="individual-primary-skill row m-0  mt-3 d-flex"
                              [ngClass] = "{'background' :  certification.isExpired}"
                              *ngIf="certification.status == 3">
                              <div *ngIf="certification.isExpired">
                                <div class="verticalLine1"></div>
                                <h6 class="expired-label">
                                  &nbsp;<span>Expired</span>
                                </h6>
                                <div class="verticalLine2"></div>
                              </div>
                              <div class="col-11 p-0 " [ngClass]="{'disabled': certification.isExpired}" >
                                <div class="row row-gap16 m-0">
                                  <div class="col-md-3 mat-card-header flex-column text-nowrap">

                                    <label class="type"><b>Certification Name</b><sup>*</sup></label>
                                    <div class="ml-1">
                                      <input type="text" class="form-control type" aria-label="Number" matInput
                                        [(ngModel)]="certification.type"
                                        (input)="searchCertificationtype(certification.type)"
                                        (click)="searchCertificationtype('')"
                                        [ngClass]="certification.isInvalidType ? 'is-invalid1' : ''"
                                        placeholder="Select Certification Name" [matAutocomplete]="completedCertificate"
                                        [disabled]="isViewMode">
                                    </div>
                                    <mat-autocomplete autoActiveFirstOption #completedCertificate="matAutocomplete"
                                      (optionSelected)="certification.type=$event.option.value;certification.isInvalidType=false;
                                      certification.certificateLevel=getlevel(certification.type);">
                                      <mat-option *ngFor="let type of filtercertificateType" [value]="type.name">
                                        {{type.name}}
                                      </mat-option>
                                    </mat-autocomplete>
                                    <div *ngIf="certification.alreadySelectedType" class="invalid-feedback feedback">
                                      Name
                                      already
                                      selected.</div>
                                  </div>
                                  <div class="col-md-3 flex-column d-flex">
                                    <label class="level"><b>Level</b><sup>*</sup></label>
                                    <div class="btn-group level disabled">
                                      <button type="button" class="btn mybtn"
                                        [ngClass]="{'active':certification.certificateLevel==1}"
                                        [disabled]="isViewMode">Beginner</button>
                                      <button type="button" class="btn mybtn"
                                        [ngClass]="{'active':certification.certificateLevel==2}"
                                        [disabled]="isViewMode">Intermediate</button>
                                      <button type="button" class="btn mybtn"
                                        [ngClass]="{'active':certification.certificateLevel==3}"
                                        [disabled]="isViewMode">Expert</button>
                                    </div>
                                  </div> 
                                  <div class="col-md-3 pl-0">
                                    <label><b>Completion date</b><sup>*</sup></label>
                                    <input type="date" class="form-control" [(ngModel)]="certification.completedDate"
                                      (change)="certification.isInvalidCompletedDate=false; certification.expiryDate = expiryyr(certification.type,certification.completedDate)"
                                      [ngClass]="certification.isInvalidCompletedDate ? 'is-invalid1' : ''"
                                      [disabled]="isViewMode"
                                      [max]="certification.status == 1 || certification.status == 3 ? todayDate:''" />
                                  </div>
                                  <div class="col-md-3  d-flex flex-column">
                                    <label class="expiry"><b>{{certification.status ==
                                        3?"Expiry date":"Date"}}</b><sup>*</sup></label>
                                    <input type="date" class="form-control expiry"
                                      [(ngModel)]="certification.expiryDate"
                                      (change)="certification.isInvalidExpiryDate=false"
                                      [ngClass]="certification.isInvalidExpiryDate ? 'is-invalid1' : ''"
                                      [disabled]="true"
                                     />
                                  </div>
                                  <div class="col-md-3">
                                    <label><b>Service area</b></label>
                                    <select class="form-control" [(ngModel)]="certification.serviceAreaId">
                                      <option value="0" disabled selected>Select service area</option>
                                      <option *ngFor="let data of certificateServiceAreas" [value]="data.id">
                                        {{data.name}}</option>
                                    </select>
                                  </div>
                                  <div class="col-md-2 upload_certificate">
                                    <div class="">
                                      <button class="custom_btn inverted_btn_base mt-2 d-flex align-items-center"
                                        (click)="uploadCertificates(certification)"><i
                                          class="material-symbols-outlined mr-2">upload_file</i>Upload
                                        documents</button>
                                    </div>
                                  </div>
                                  <div class="col-md-4 certification-tagging">
                                    <mat-checkbox class="custom-mdc-checkbox custom_mdc_checkbox custom_mdc_checkbox2"
                                      [(ngModel)]="certification.certificateTagging">
                                      <span class="domain_text">Certification tagging</span>
                                      <span class="ml-2 material-symbols-outlined infoicon fs-16">
                                        info
                                        <div class="infoimage">
                                          <img src="../../../assets/images/dashboard/MicrosoftTeams-image (4).png"
                                            alt="certifications" width="100%" height="100%">
                                        </div>
                                      </span>
                                    </mat-checkbox>
                                  </div>
                                  <div class="certificate_chips_list" *ngIf="certification.certificateAttachment">
                                    <div *ngFor="let file of certification.certificateAttachment, let i=index"
                                      class="certificateAttachment">
                                      <div class="d-flex certificate_chips">
                                        <div class="file-name file-name-text" [title]="file.name">
                                          {{file.name}}
                                        </div>

                                      </div>
                                      <div class="certificate-icons">
                                        <div>
                                          <i class="fas fa-eye py-3 px-bottom-icons"
                                            [class.disabled]="!file.sharepointId"
                                            (click)="viewFile(file?.sharepointId)"></i>
                                        </div>
                                        <div>
                                          <i class="fas fa-download py-3 px-bottom-icons"
                                            [class.disabled]="!file.sharepointId"
                                            (click)="downloadResume(file?.sharepointId,file?.name)"></i>
                                        </div>
                                        <i class="fas fa-trash px-bottom-icons py-3"
                                          (click)="deleteCertificateAttachment(certification,i)"></i>
                                      </div>
                                    </div>
                                  </div>

                                </div>

                              </div>
                              <div class="col-12 col-md-6 col-lg-1 pr-0 mt-3 close_buttons_container">
                                <button class="gsd_close_btn2 "
                                  (click)="deleteCertification(index,certification,subCompetency?.certificates)"
                                  [disabled]="isViewMode"><i class="material-symbols-outlined">close</i></button>
                              </div>

                            </div>
                          </div>


                        </div>
                      </div>
                    </div>


                  </mat-tab>

                  <mat-tab>
                    <ng-template mat-tab-label>
                      <div class="d-flex align-items-center">
                        <span class="material-symbols-outlined mr-2 fs_20">add_comment</span>
                        <span>Comments</span>
                      </div>
                    </ng-template>


                    <textarea [(ngModel)]="employee.comments" rows="5" class="form-control comment_description"
                      [disabled]="!isEmployeeEditable || employee?.employeeProfileStatus!==1" type="text"
                      placeholder="Write a comment..." [class.error]="commentsError"></textarea>
                    <div class="error-message mb-1 ml-1" *ngIf="commentsError">{{commentsError}}</div>


                  </mat-tab>
                </mat-tab-group>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
      <div class="button_section my-3">
        <div *ngIf="employee?.employeeProfileStatus==1" class="button_section">
          <button mat-flat-button *ngIf="isEmployeeEditable" class="custom_btn true1_btn"
            (click)="approveApproval()">Approve</button>
          <button mat-flat-button *ngIf="isEmployeeEditable" class="custom_btn reject_btn"
            (click)="rejectApproval()">Reject</button>
        </div>
        <div *ngIf="(isEditScreen) || isUserEditable" class="button_section">
          <button mat-flat-button class="custom_btn inverted_btn_base" (click)="cancelEdit()">
            <span *ngIf="isViewMode">Back</span>
            <span *ngIf="!isViewMode">Cancel</span>
          </button>
          <button *ngIf="isSavebuttonvisible" mat-flat-button class=" custom_btn primary_btn_base" (click)="saveCompetency()">Save</button>
          <button mat-flat-button class=" custom_btn inverted_btn_base" style="float: right;" (click)="backButton()"
            *ngIf="isViewMode">Back</button>
        </div>

      </div>
    </div>
  </div>
</div>